/**
 * @generated SignedSource<<cf7f4f738e4daf80b9d893ce6e1a9935>>
 * @relayHash 829389f5f6086ae52dcb0b5f3b8ec22a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 829389f5f6086ae52dcb0b5f3b8ec22a

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteBodyMeasurementInput = {
  id: string;
};
export type chDeleteBodyMeasurementMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_deleteBodyMeasurementInput;
};
export type chDeleteBodyMeasurementMutation$data = {
  readonly deleteBodyMeasurement: {
    readonly bodyMeasurement: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chDeleteBodyMeasurementMutation = {
  response: chDeleteBodyMeasurementMutation$data;
  variables: chDeleteBodyMeasurementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chDeleteBodyMeasurementMutation",
    "selections": [
      {
        "alias": "deleteBodyMeasurement",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteBodyMeasurementPayload",
        "kind": "LinkedField",
        "name": "ch_deleteBodyMeasurement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BodyMeasurement",
            "kind": "LinkedField",
            "name": "bodyMeasurement",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chDeleteBodyMeasurementMutation",
    "selections": [
      {
        "alias": "deleteBodyMeasurement",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteBodyMeasurementPayload",
        "kind": "LinkedField",
        "name": "ch_deleteBodyMeasurement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BodyMeasurement",
            "kind": "LinkedField",
            "name": "bodyMeasurement",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "829389f5f6086ae52dcb0b5f3b8ec22a",
    "metadata": {},
    "name": "chDeleteBodyMeasurementMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ecb3daa6ab87979b86ce537add6446bd";

export default node;
